import alt from "../alt";
import indexBy from "lodash/keyBy";
import mergeWith from "lodash/mergeWith";
import uniqBy from "lodash/uniqBy";
import EventFetcher from "../utils/EventFetcher";
import FilmActions from "../actions/FilmActions";
import PersonStore from "../stores/PersonStore";

class FilmStore {
  constructor() {
    this.bindActions(FilmActions);

    this.state = {
      films: {},
      isFetchingAll: false,
      hasFetchedAll: false,
      isFetchingAllForced: false,
      hasFetchedAndForcedAll: false,
      hasUpdatedFilms: false
    };

    this.exportPublicMethods({
      getFilmById: this.getFilmById.bind(this)
    });
  }

  getFilmById(id) {
    return this.state.films[id];
  }

  onFetchAll(opts) {
    const forceAll = opts ? opts.forceAll : false;

    this.setState({
      isFetchingAll: true,
      isFetchingAllForced: forceAll
    });

    EventFetcher.fetchAllFilms(PersonStore.getState().token, { forceAll }).then(
      ({ films }) => {
        this.setState({
          isFetchingAll: false,
          hasFetchedAll: true,
          hasFetchedAndForcedAll: this.state.hasFetchedAndForcedAll || forceAll
        });
        FilmActions.updateFilms(indexBy(films, "id"));
      }
    );
  }

  onFetchOne(id) {
    EventFetcher.fetchOneFilm(PersonStore.getState().token, id).then(data => {
      FilmActions.updateFilm(id, data);
    });
  }

  onUpdateFilms(films) {
    function customizer(objValue, srcValue) {
      // Ensure we don't duplicate unique id'd objects - and preserve the
      // "newer" one when possible (by concatenating with the src first).
      if (Array.isArray(srcValue)) {
        return uniqBy(srcValue.concat(objValue || []), o =>
          o ? o.id || o : undefined
        );
      }
    }

    let updated = mergeWith(this.state.films, films, customizer);
    this.setState({ films: updated, hasUpdatedFilms: true });
  }

  onUpdateFilm(data) {
    FilmActions.updateFilms.defer({ [data.id]: data.film });
  }
}

export default alt.createStore(FilmStore, "FilmStore");



// WEBPACK FOOTER //
// ./src/app/stores/FilmStore.js